<dx-scroll-view>
  <div class="flex items-stretch">
    <div class="p-8 flex-1">
      <form (submit)="onFormSubmit($event)" id="profileForm" enctype="multipart/form-data">
        <dx-form id="profileEditForm"
                 (onFieldDataChanged)="onFieldDataChanged($event)"
                 [colCount]="4"
                 [readOnly]="false"
                 [showColonAfterLabel]="true"
                 [showValidationSummary]="true">
          <dxi-item itemType="group">
            <dxi-item>
              <div *dxTemplate>

                <lib-profile-photo-upload
                  [(loading)]="loadIndicatorVisible"
                  [value]="user.photo"
                  (valueChange)="photoChange($event)"></lib-profile-photo-upload>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colSpan]="3" caption="Données Personnelles">
            <dxi-item [label]="{text: 'Nom et Prènom'}" dataField="name" [editorOptions]="{value: user.name}">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [label]="{text: 'Téléphone'}" dataField="phone"
                      [editorOptions]="{mask: '+212 0 00 00 00 00', maskRules: phonePattern, useMaskedValue:true, value: user.phone}">
              <dxi-validation-rule type="required"></dxi-validation-rule>
              <dxi-validation-rule type="pattern" [pattern]="phonePattern"></dxi-validation-rule>
              <dxi-validation-rule type="stringLength" [max]="45"></dxi-validation-rule>
            </dxi-item>
            <dxi-item [label]="{text: 'Email'}" dataField="email"
                      [editorOptions]="{readOnly:true, value: user.email}"></dxi-item>
          </dxi-item>
          <dxi-item
            [colSpan]="4"
            itemType="button"
            horizontalAlignment="right"
            [buttonOptions]="buttonOptions">
          </dxi-item>
        </dx-form>
      </form>
    </div>
    <dx-load-panel
      shadingColor="rgba(0,0,0,0.4)"
      [position]="{ of: '#profileForm' }"
      [(visible)]="loadIndicatorVisible"
      [showIndicator]="true"
      [showPane]="true"
      [shading]="true"
      [closeOnOutsideClick]="false">
    </dx-load-panel>

    <div class="p-8 flex-1">
      <form (submit)="onChangePasswordSubmit($event)">
        <dx-form id="passwordChangeForm"
                 [formData]="passwordChangeRequest"
                 [readOnly]="false"
                 [showColonAfterLabel]="true"
                 [showValidationSummary]="true">
          <dxi-item itemType="group" caption="Changer le mot de passe">

            <dxi-item [label]="{text: 'Mot de Passe Actuel'}" dataField="old_password"
                      [editorOptions]="{mode: 'password'}">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [label]="{text: 'Nouveau Mot de Passe'}" dataField="new_password"
                      [editorOptions]="{mode: 'password'}">
              <dxi-validation-rule type="required"></dxi-validation-rule>
              <dxi-validation-rule type="stringLength" [min]="8" [max]="150"
                                   message="La longueur minimale du mot de passe est de 8 caractères"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [label]="{text: 'Confirmation du Mot de Passe'}" dataField="new_password_confirm"
                      [editorOptions]="{mode: 'password'}">
              <dxi-validation-rule type="required"></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="passwordComparison"
                message="La confirmation du mot de passe ne correspond pas">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>
          <dxi-item
            itemType="button"
            horizontalAlignment="right"
            [buttonOptions]="changePasswordBtnOptions">
          </dxi-item>
        </dx-form>
      </form>
    </div>
  </div>
</dx-scroll-view>


